
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contatti",
      function () {
        return require("private-next-pages/contatti.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contatti"])
      });
    }
  